import React from 'react';

const TableError: React.FC = () => {
    return <div />;
};

export default TableError;
